export function toPersianDigits(input) {
  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  return String(input).replace(/\d/g, (digit) => persianDigits[digit]);
}
